const didNotRun = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path stroke-width="1.5" d="M14.102 4.083A7.216 7.216 0 0 1 15.25 8a7.227 7.227 0 0 1-2.123 5.127A7.227 7.227 0 0 1 8 15.25a7.216 7.216 0 0 1-3.676-1ZM8 .75c1.345 0 2.604.366 3.684 1.004L1.886 11.898A7.216 7.216 0 0 1 .75 8c0-2.002.811-3.815 2.123-5.127A7.227 7.227 0 0 1 8 .75Z"/></svg>',
};

export { didNotRun as default };
